<div class="embed-container">
	<!-- <bb-inline-message *ngIf="showInlineMessage" [message]="inlineMessage" [type]="inlineMessageType"></bb-inline-message> -->
	<embed-preview class="contents"
		[project]="project"
		[mediaclip]="mainMediaClip"
		[configuration]="{standAlone: true, autoPlay: false, alwaysShow: true}"
		[isActive]="isActive">
		<div class="custom-warning">
			<span *ngIf="mainMediaClip && project && project.status === 'draft'" class="message warning ng-binding">
				<i class="fa" ></i>&nbsp;{{ 'HELP.PROJECT_NOT_PUBLISHED' | translate }}.&nbsp;<button class="button publish-button" (click)="publishProject();" [hidden]="embed">PUBLISH</button>
			</span>
			<span *ngIf="mainMediaClip && project.status === 'published' && draftClips.length > 0" class="message warning ng-binding">
				<i class="fa fa-warning" ></i>{{draftClips.length}}&nbsp;{{ 'HELP.PROJECT_DRAFT_MEDIACLIPS' | translate }}.
			</span>
			
		</div>
	</embed-preview>
</div>
